var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7329 70H8.30861C3.73887 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69733 0 8.30861 0H61.7329C66.3027 0 70.0415 3.69733 70.0415 8.30861V61.7329C70.0415 66.3027 66.3027 70 61.7329 70Z",
    fill: "#BBD148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1855 31.4746H26.3867C26.5156 28.6855 27.3887 26.4941 29.0059 24.9004C30.6348 23.2949 32.7207 22.4922 35.2637 22.4922C36.834 22.4922 38.2168 22.8262 39.4121 23.4941C40.6191 24.1504 41.5801 25.1055 42.2949 26.3594C43.0215 27.6016 43.3848 28.8672 43.3848 30.1562C43.3848 31.6914 42.9453 33.3438 42.0664 35.1133C41.1992 36.8828 39.6055 38.9746 37.2852 41.3887L34.3848 44.4473H43.5957V49H25.6836V46.6445L33.6816 38.4883C35.6152 36.5312 36.8984 34.9609 37.5312 33.7773C38.1758 32.582 38.498 31.5039 38.498 30.543C38.498 29.5469 38.1641 28.7266 37.4961 28.082C36.8398 27.4258 35.9902 27.0977 34.9473 27.0977C33.8926 27.0977 33.0137 27.4902 32.3105 28.2754C31.6074 29.0605 31.2324 30.127 31.1855 31.4746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.ba749ec273704f77f808d35c411ae4d6.svg";
export { ForwardRef as ReactComponent };